export default "__VITE_ASSET__5e6d3356__"